import TableLoader from "../../../Common/ShimmerLoader/TableLoader";
import isGHMC from "../../../Common/helper/helpar";
import {
  getTableHeaderStyle,
  sectionHeaderStyle,
  tableCellStyle,
} from "./routeVehicleModalUtils";

const STOPPAGE_COLUMNS = ["Sl.", "Stoppage Point", "Sequence", "Action"];

const RouteStoppagePointsSection = ({
  stoppages = [],
  isLoadingRoute = false,
  onEditStoppage,
  onDeleteStoppage,
  onAddStoppage,
}) => {
  const tableHeaderStyle = getTableHeaderStyle(isGHMC());

  return (
    <>
      <h6 className="mb-0" style={sectionHeaderStyle}>
        Route Stoppage Points
      </h6>

      <div
        className="mb-3"
        style={{
          overflow: "hidden",
          borderRadius: 8,
          border: "1px solid #E0E0E0",
        }}
      >
        {isLoadingRoute ? (
          <TableLoader height={220} rows={4} columns={4} />
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                minWidth: 720,
                borderCollapse: "separate",
                borderSpacing: 0,
              }}
            >
              <thead>
                <tr>
                  {STOPPAGE_COLUMNS.map((column) => (
                    <th key={column} style={tableHeaderStyle}>
                      {column}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!stoppages.length ? (
                  <tr>
                    <td colSpan={4} style={tableCellStyle}>
                      No stoppage points added
                    </td>
                  </tr>
                ) : (
                  stoppages.map((stoppage, index) => (
                    <tr key={stoppage.id ?? index}>
                      <td style={tableCellStyle}>{index + 1}</td>
                      <td style={tableCellStyle}>
                        {stoppage.name || stoppage.locationName || "-"}
                      </td>
                      <td style={tableCellStyle}>{stoppage.sequence}</td>
                      <td style={tableCellStyle}>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary me-2"
                          onClick={() => onEditStoppage(index)}
                        >
                          <i className="fa-solid fa-pen me-1" />
                          Edit
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => onDeleteStoppage(index)}
                        >
                          <i className="fa-solid fa-trash me-1" />
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="text-center mb-3">
        <button
          type="button"
          className="btn btn-outline-primary px-4"
          onClick={onAddStoppage}
          disabled={isLoadingRoute}
        >
          <i className="fa-solid fa-plus me-2" />
          ADD STOPPAGE
        </button>
      </div>
    </>
  );
};

export default RouteStoppagePointsSection;
